/* Tabbladen. Progressieve verbetering: zonder dit bestand staat het eerste
   paneel open en zijn de andere via hun id bereikbaar. Haken zijn
   data-attributen, geen classes. */

(function () {
  'use strict';

  class Tabs extends HTMLElement {
    connectedCallback() {
      this.knoppen = [...this.querySelectorAll('[data-tab]')];
      this.panelen = [...this.querySelectorAll('[data-tab-panel]')];

      /* Losse dingen die met een tabblad meelopen maar er niet in staan: de
         knop "Bekijk alles" hoort naast de tabbladen en niet onder de
         producten, terwijl hij per tabblad naar een andere collectie wijst.
         Zo'n element draagt data-tab-extra met de id van zijn paneel. */
      this.extras = [...this.querySelectorAll('[data-tab-extra]')];

      if (!this.knoppen.length) return;

      this.knoppen.forEach((knop) => {
        knop.addEventListener('click', () => this.toon(knop.getAttribute('data-tab')));
      });

      // Pijltjes links en rechts door de tabbladen, zoals een tablist hoort.
      this.addEventListener('keydown', (e) => {
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
        const i = this.knoppen.indexOf(document.activeElement);
        if (i < 0) return;
        e.preventDefault();
        const stap = e.key === 'ArrowRight' ? 1 : -1;
        const n = this.knoppen.length;
        const doel = this.knoppen[((i + stap) % n + n) % n];
        doel.focus();
        this.toon(doel.getAttribute('data-tab'));
      });
    }

    toon(id) {
      this.knoppen.forEach((k) => {
        const aan = k.getAttribute('data-tab') === id;
        k.classList.toggle('is-actief', aan);
        k.setAttribute('aria-selected', aan ? 'true' : 'false');
      });
      this.panelen.forEach((p) => {
        p.hidden = p.id !== id;
      });
      this.extras.forEach((e) => {
        e.hidden = e.getAttribute('data-tab-extra') !== id;
      });
    }
  }

  if (!customElements.get('hws-tabs')) customElements.define('hws-tabs', Tabs);
})();
